import { type Field, type TypeInstanceMap, VariableType } from '@lighthouse/core'
import type { JSONContent } from '@tiptap/react'

export type { JSONContent } from '@tiptap/react'

interface DataQuote {
    name: string
    type: string
    innerType?: TypeInstanceMap
}

function parseExpression(expression: string, content: JSONContent[], index = 0) {
    return ({ fieldBiMap }: ReturnType<typeof createDsAndFieldMap>): JSONContent[] => {
        const str = expression.replace(/\$?\{(\w{2,70})\}/u, ($0: string, $1: string) => {
            const idx = expression.indexOf($0)
            if (idx !== 0) {
                const text = expression.slice(0, Math.max(0, idx))
                content.push({
                    type: 'text',
                    text: expression.slice(0, Math.max(0, idx))
                })
                index += text.length
            }
            if ($1 === 'currentValue') {
                content.push({
                    type: 'text',
                    text: $0
                })
                return ''
            }
            content.push({
                type: 'variable',
                attrs: {
                    value: {
                        type: VariableType.FIELD_ID,
                        fieldIdVariable: {
                            fieldId: $1
                        }
                    }
                }
            })

            return ''
        })

        const surplusStr = str.slice(Math.max(0, index))
        if (/\$?\{(\w{2,70})\}/u.test(surplusStr)) {
            return parseExpression(surplusStr, content, 0)({ fieldBiMap })
        }
        if (surplusStr.trim()) {
            content.push({
                type: 'text',
                text: surplusStr
            })
        }

        return content
    }
}

export function decodeExpression(expression: string) {
    return ({ fieldBiMap }: ReturnType<typeof createDsAndFieldMap>) => {
        if (!expression) {
            return { content: [{ content: [], type: 'doc' }] }
        }
        const arr = expression.split('\n')
        const content: JSONContent[] = []
        arr.forEach(item => {
            if (!item) {
                content.push({ type: 'paragraph' })
                return
            }
            const contentItem: JSONContent[] = parseExpression(item, [])({ fieldBiMap }) ?? []
            content.push({ type: 'paragraph', content: contentItem })
        })

        return {
            content,
            type: 'doc'
        }
    }
}

export function createDsAndFieldMap(fields: Field[]) {
    const fieldBiMap = new Map<string, DataQuote>()
    function generatorMap(DsFields: Field[]) {
        for (const field of DsFields) {
            const { id, name, type, innerType } = field
            const safeName = name.replaceAll('"', '\\"') || ''
            fieldBiMap.set(id, { name: safeName, type, innerType })
        }
    }
    generatorMap(fields)
    return { fieldBiMap }
}
